import React from 'react';
import { Link } from 'gatsby';

export default () => (
  <nav className="max-width-40-rem">
    <Link to="/">Home</Link>
    &nbsp;|&nbsp;
    <Link to="/#projects">Projects</Link>
    &nbsp;|&nbsp;
    <Link to="/#events">Events</Link>
    &nbsp;|&nbsp;
    <Link to="/#talks">Talks</Link>
  </nav>
);
